import React from "react";
import styled from "styled-components";
import { ITheme } from "../../Themes/ThemeTypes";

const Div = styled.div<{ theme: ITheme }>`
  padding-left: 16px;
`;

interface ListItemTrailingElementProps {
  children: React.ReactNode;
}

const ListItemTrailingElement: React.FC<ListItemTrailingElementProps> = ({ children }) => {
  return <Div>{children}</Div>;
};

export default ListItemTrailingElement;
